import "./EquipmentType.html";

import "./BasicInformation/BasicInformationComponent";
import "./EquipmentFunctionalities/EquipmentFunctionalitiesComponent";

import type { IComponentOptions, IControllerConstructor, Injectable } from "angular";
import { module } from "angular";
import EquipmentTypeComponentController from "./EquipmentTypeComponentController";

export default class EquipmentTypeComponent implements IComponentOptions {
    public bindings: any;

    public controller: Injectable<IControllerConstructor>;

    public templateUrl: string;

    constructor() {
        this.bindings = {
            equipmentTypeId: "<",
        };
        this.controller = EquipmentTypeComponentController;
        this.templateUrl = "/App/Components/EquipmentType/EquipmentType.html";
    }
}

module("mmManagePortal").component("irEquipmentTypeDetails", new EquipmentTypeComponent());
